import { Box, Stack } from "@mui/material";
import { PrimaryEditLink, StyledDivider } from "react-common-ui-library";
import { useNavigate } from "react-router-dom";
import {
  StyledAccountSettingsHeader,
  StyledFieldLabelTypography,
  StyledFieldValueTypography,
  StyledLoginInformationBox,
  StyledPasswordDisplayStack,
  StyledTypographyHeader,
} from "../../../Styles/MyProfile/LoginInformation/LoginInformation";

import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import {
  CIRCLE_UNICODE,
  H1,
  H3,
  LOGIN_INFORMATION_ROUTE,
  MY_PROFILE_ACCOUNT_SETTINGS_ROUTE,
  RESET_PASSWORD_ROUTE,
  SUBTITLE,
} from "../../../Constants/CommonConstants";
import {
  MY_PROFILE_LOGIN_INFORMATION_PASSWORD,
  MY_PROFILE_LOGIN_INFORMATION_PASSWORD_VALUE,
  MY_PROFILE_LOGIN_INFORMATION_RESET_PASSWORD_LABEL,
  MY_PROFILE_LOGIN_INFORMATION_RESET_PASSWORD_LINK,
  MY_PROFILE_LOGIN_INFORMATION_USERNAME,
  MY_PROFILE_LOGIN_INFORMATION_USERNAME_VALUE,
} from "../../../Constants/LoginInformationConstants";
import {
  MY_PROFILE_ACCOUNT_SETTINGS,
  MY_PROFILE_LOGIN_INFORMATION_LABEL,
} from "../../../Constants/MyProfileSideNav";
import { ACCOUNT_SETTING_LABEL } from "../../../Constants/MyProfileConstants";

import { manageAuthorizationSelector } from "../../../Selectors/AuthorizationSelector";
import { USER_TYPE_CONSUMER } from "../../../Constants/AccountSetupConstants";

const LoginInformation = () => {
  const navigate = useNavigate();

  const intl = useIntl();

  const { userName, scopes } = useSelector((state) =>
    manageAuthorizationSelector(state)
  );

  const navigateToResetPassword = () => {
    navigate(`/${MY_PROFILE_ACCOUNT_SETTINGS_ROUTE}/${RESET_PASSWORD_ROUTE}`, {
      state: {
        previousScreen: LOGIN_INFORMATION_ROUTE,
        userName: userName,
        isConsumer: scopes === USER_TYPE_CONSUMER,
      },
    });
  };

  return (
    <StyledLoginInformationBox>
      <Stack gap={5}>
        <Stack gap={2}>
          <StyledAccountSettingsHeader
            id={ACCOUNT_SETTING_LABEL}
            component={H1}
            variant={SUBTITLE}
          >
            {intl.formatMessage({
              id: MY_PROFILE_ACCOUNT_SETTINGS,
            })}
          </StyledAccountSettingsHeader>

          <StyledTypographyHeader
            id={MY_PROFILE_LOGIN_INFORMATION_LABEL}
            component={H1}
            variant={H3}
          >
            {intl.formatMessage({
              id: MY_PROFILE_LOGIN_INFORMATION_LABEL,
            })}
          </StyledTypographyHeader>
        </Stack>
        <Box>
          <Stack gap={1.5}>
            <StyledFieldLabelTypography
              id={MY_PROFILE_LOGIN_INFORMATION_USERNAME}
            >
              {intl.formatMessage({
                id: MY_PROFILE_LOGIN_INFORMATION_USERNAME,
              })}
            </StyledFieldLabelTypography>
            <StyledFieldValueTypography
              id={MY_PROFILE_LOGIN_INFORMATION_USERNAME_VALUE}
            >
              {userName}
            </StyledFieldValueTypography>
          </Stack>
          <StyledDivider sx={{ my: 4 }} />
          <Stack gap={1.5}>
            <StyledFieldLabelTypography
              id={MY_PROFILE_LOGIN_INFORMATION_PASSWORD}
            >
              {intl.formatMessage({
                id: MY_PROFILE_LOGIN_INFORMATION_PASSWORD,
              })}
            </StyledFieldLabelTypography>
            <StyledPasswordDisplayStack>
              <StyledFieldValueTypography
                id={MY_PROFILE_LOGIN_INFORMATION_PASSWORD_VALUE}
              >
                {scopes === USER_TYPE_CONSUMER
                  ? CIRCLE_UNICODE.repeat(8)
                  : CIRCLE_UNICODE.repeat(15)}
              </StyledFieldValueTypography>
              <PrimaryEditLink
                id={MY_PROFILE_LOGIN_INFORMATION_RESET_PASSWORD_LINK}
                label={intl.formatMessage({
                  id: MY_PROFILE_LOGIN_INFORMATION_RESET_PASSWORD_LABEL,
                })}
                onClick={navigateToResetPassword}
              />
            </StyledPasswordDisplayStack>
          </Stack>
        </Box>
      </Stack>
    </StyledLoginInformationBox>
  );
};

export default LoginInformation;
